import { render } from "./SortList.vue?vue&type=template&id=c4253d10&scoped=true"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"

import "./SortList.vue?vue&type=style&index=0&id=c4253d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4253d10"]])

export default __exports__